var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSubscribe = function SvgSubscribe(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#838D93",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m9 15.435 11 8.001 11-8V28H9V15.435M30.95 13 20 20.964 9.05 12.999h21.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSubscribe);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IGZpbGw9IiM4MzhEOTMiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIwIj48L3JlY3Q+CiAgICA8cGF0aCBkPSJNOC45OTkwOTIyMiwxNS40MzUwOTIyIEwyMCwyMy40MzY0OTczIEwzMC45OTkwOTIyLDE1LjQzNjA5MjIgTDMxLDI4IEw5LDI4IEw4Ljk5OTA5MjIyLDE1LjQzNTA5MjIgWiBNMzAuOTUwMDkyMiwxMi45OTkwOTIyIEwyMCwyMC45NjM1MDI3IEw5LjA0OTA5MjIyLDEyLjk5OTA5MjIgTDMwLjk1MDA5MjIsMTIuOTk5MDkyMiBaIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+Cjwvc3ZnPg==";